import prompts from './prompts';
import { Button, Typography } from '@cobliteam/ui/components';

interface ExamplePromptProps {
  onPromptClick: (prompt: string) => void;
}

const ExamplePrompt = ({ onPromptClick }: ExamplePromptProps) => {
  return (
    <div className='grid w-full grid-cols-2 gap-4'>
      {prompts.map((prompt) => (
        <Button variant='outlined' color='default' className='h-24 w-full text-wrap' key={prompt.id} onClick={() => onPromptClick(prompt.input)}>
          <Typography>{prompt.input}</Typography>
        </Button>
      ))}
    </div>
  );
};

export default ExamplePrompt;
